var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2920",
    "data-name": "Group 2920",
    transform: "translate(-4048 -11474.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    transform: "translate(4048 11474.526)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 15.2,
    height: 15.2,
    rx: 3.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_29",
    "data-name": "Polygon 29",
    transform: "translate(4050 11476.526)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0,7.56,4.376,12,4.584,8.524,7.5,9.708,12,6,9.424,2.292,12,3.476,7.5,0,4.584l4.44-.208Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 2.382309913635254 L 5.193540096282959 4.644420146942139 L 5.013370037078857 5.149819850921631 L 4.477399826049805 5.174910068511963 L 2.085101127624512 5.286879062652588 L 3.989640235900879 6.882559776306152 L 4.378590106964111 7.20842981338501 L 4.249579906463623 7.699170112609863 L 3.61705207824707 10.10531520843506 L 5.543590068817139 8.767020225524902 L 6 8.449970245361328 L 6.456409931182861 8.767020225524902 L 8.38294792175293 10.10531520843506 L 7.750420093536377 7.699170112609863 L 7.621409893035889 7.20842981338501 L 8.010359764099121 6.882559776306152 L 9.914898872375488 5.286879062652588 L 7.522600173950195 5.174910068511963 L 6.986629962921143 5.149819850921631 L 6.806459903717041 4.644420146942139 L 6 2.382309913635254 M 6 0 L 7.559999942779541 4.37578010559082 L 12 4.583590030670166 L 8.524129867553711 7.495779991149902 L 9.708200454711914 12 L 6 9.424050331115723 L 2.291799545288086 12 L 3.475870132446289 7.495779991149902 L 0 4.583590030670166 L 4.440000057220459 4.37578010559082 L 6 0 Z",
    stroke: "none",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.00b9e4fb9aae217c8ebd3f8368c69c31.svg";
export { ForwardRef as ReactComponent };